var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgStampReject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2203_62403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3 14.875H3.29999C3.29999 11.5 4.48415 11.5 6.45832 11.5C10.8 11.5 7.46665 7.675 7.46665 5.83333C7.46665 4.94928 7.81784 4.10143 8.44296 3.47631C9.06809 2.85119 9.91593 2.5 10.8 2.5C11.684 2.5 12.5319 2.85119 13.157 3.47631C13.7821 4.10143 14.1333 4.94928 14.1333 5.83333C14.1333 7.675 10.8 11.5 15.1417 11.5C17.1158 11.5 18.3 11.5 18.3 14.875Z",
    stroke: "#002244",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96664 17.5H16.6333",
    stroke: "#002244",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.365 17.2492C19.5855 17.0286 19.7 16.7484 19.7 16.4377C19.7 16.127 19.5855 15.8468 19.365 15.6262L17.7388 14L19.365 12.3738C19.5855 12.1532 19.7 11.873 19.7 11.5623C19.7 11.2516 19.5855 10.9714 19.365 10.7508L18.4492 9.835C18.2287 9.61446 17.9484 9.5 17.6377 9.5C17.3271 9.5 17.0468 9.61446 16.8263 9.835L15.2 11.4612L13.5738 9.835C13.3532 9.61446 13.073 9.5 12.7623 9.5C12.4516 9.5 12.1714 9.61446 11.9508 9.835L11.035 10.7508C10.8145 10.9714 10.7 11.2516 10.7 11.5623C10.7 11.873 10.8145 12.1532 11.035 12.3738L12.6613 14L11.035 15.6262C10.8145 15.8468 10.7 16.127 10.7 16.4377C10.7 16.7484 10.8145 17.0286 11.035 17.2492L11.9508 18.165C12.1714 18.3855 12.4516 18.5 12.7623 18.5C13.073 18.5 13.3532 18.3855 13.5738 18.165L15.2 16.5388L16.8263 18.165C17.0468 18.3855 17.3271 18.5 17.6377 18.5C17.9484 18.5 18.2287 18.3855 18.4492 18.165L19.365 17.2492Z",
    fill: "#EA2727",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2203_62403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.799988)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgStampReject);
export default __webpack_public_path__ + "static/media/svg_stamp_reject.4e391c84b99156d65e4f7033160ed006.svg";
export { ForwardRef as ReactComponent };